exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.BookingsPage[data-v-7cc8a06f] {\n  min-height: 100vh;\n}\n.table td[data-v-7cc8a06f] {\n  font-size: 13px;\n  font-wieght: 500;\n}\n.bookingCode[data-v-7cc8a06f] {\n  margin-left: 0;\n}\n.promotionalCode[data-v-7cc8a06f] {\n  color: #bb2222;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cc8a06f","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/AdminBookings.vue
// module id = 663
// module chunks = 3